import { render, staticRenderFns } from "./AmazonAlexaDownloadInteractionModelButton.vue?vue&type=template&id=30f740c1"
import script from "./AmazonAlexaDownloadInteractionModelButton.vue?vue&type=script&lang=ts"
export * from "./AmazonAlexaDownloadInteractionModelButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports